/*
 * @Author: your name
 * @Date: 2021-07-24 15:17:54
 * @LastEditTime: 2021-07-31 15:37:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hpss-ui\src\api\crmedical\value\valuebudget.js
 */
import request from '@/util/request';
import qs from 'qs';
//价值分析table
export const getList = (params, options) =>
request.get('/api/v4ward/valueBudget/page', Object.assign({}, options, { params }));

//获取部门
export const getDepatment =(params, options) =>
request.get('/api/v4ward/knowledgeGroupFile/getDept', Object.assign({}, options, { params }));

//获取编辑数据
export const getEditDetail = (params, options) =>
request.get('/api/v4ward/valueBudget/detail', Object.assign({}, options, { params }));

//保存or新增
export const saveValueInfo = (params, options) =>
request.post('/api/v4ward/valueBudget/basic/save',params,options);

//提交
export const submitValueInfo = (params, options) =>
request.post('/api/v4ward/valueBudget/sugget/submit',params,options);

//获取科目
export const getValueItem = (type) =>
request.get('/api/v4ward/valueItem/getSubject?itemType='+type);

//保存价值目标
export const saveValueTarget = (params, options) =>
request.post('/api/v4ward/valueBudget/annual/update',params,options);

//获取后勤管理下拉框
export const getMangementSelect = (type) =>
request.get('/api/v4ward/valueBoundary/getBoundary?boundaryType='+type);

//后勤管理 具体内容
export const getMangementContent = (type,id) =>
request.get('/api/v4ward/valueBoundary/getBoundaryByBudgetId?boundaryType='+type+'&id='+id);

//后倾管理保存or新增
export const saveValueMangement = (params,options) =>
request.post('/api/v4ward/valueBudget/boundary/update',qs.stringify(params),options);

//组织架构设计保存or新增
export const saveOrganization= (params,options) =>
request.post('/api/v4ward/valueBudget/organization/update',params,options);

//后勤绩效考核及评价机制设计保存or新增
export const saveAccess= (params,options) =>
request.post('/api/v4ward/valueBudget/access/save',params,options);

//补充建议保存or新增
export const saveSugget= (params,options) =>
request.post('/api/v4ward/valueBudget/sugget/save',params,options);

//预览详情
export const getPreviewInfo = (id) =>
request.get('/api/v4ward/valueBudget/detail?id='+id);

//预览后勤具体内容
export const getContentName = (id) =>
request.get('/api/v4ward/valueBoundary/getNames?id='+id);

//获取用户基本信息
export const getUserInfo = (id) =>
request.get('/api/v4ward/valueBudget/getUser?id='+id);

//后勤管理边界重新规划数据获取
export const getBoundaryManagement = () =>
request.get('/api/v4ward/valueBoundary/getType');

//获取所有价值边界
export const getBoundaryTypeName = () =>
request.get('/api/v4ward/valueBoundary/getBoundaryTypeName');

// export const remove = (params, options) =>
// request.post('/api//v4ward/valueBudget/remove', qs.stringify(params),options);

// export const add = (params, options) =>
// request.post('/api//v4ward/valueBudget/save', params,options);

// export const update = (params, options) =>
// request.post('/api//v4ward/valueBudget/update', params,options);
